import WebApp from '@twa-dev/sdk';

const STORAGE_KEY = 'masha:ref';

/**
 * Захватывает id реферера при запуске приложения:
 * - ?ref=<id> в URL (bot deep link дописывает его к URL webApp-кнопки);
 * - initData start_param формата ref_<id> (direct link, на будущее).
 * Кладёт в sessionStorage — claim произойдёт после загрузки профиля.
 */
export function captureReferralParam(): void {
  try {
    const fromQuery = new URLSearchParams(window.location.search).get('ref');
    const sp = WebApp.initDataUnsafe?.start_param;
    const fromStartParam = sp && sp.startsWith('ref_') ? sp.slice(4) : null;
    const raw = fromQuery ?? fromStartParam;
    if (raw && /^\d+$/.test(raw)) {
      sessionStorage.setItem(STORAGE_KEY, raw);
    }
  } catch {
    // sessionStorage может быть недоступен — рефералка не критична
  }
}

export function getStoredReferrerId(): number | null {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const id = Number(raw);
    return Number.isInteger(id) && id > 0 ? id : null;
  } catch {
    return null;
  }
}

export function clearStoredReferrerId(): void {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}
